<div
    [class.map-container]="view() === 'map'"
    [class.show]="view() === 'map' || view() === 'list'"
    class="mapandlistcontainer"
>
    <div class="filterholder">
        @if (showPriceSelectionBar()) {
            <app-pushpin-selection
                #selection
                (chooseInspection)="chooseInspection(customerArea)"
                (updatePushpinsOnMap)="reloadPushpins()">
            </app-pushpin-selection>
        }
        <app-pushpin-move
            [customerArea]="customerArea"
            (pushpinsMoved)="reloadPushpins()"
            #move>
        </app-pushpin-move>

        <app-pushpin-map
            #pushpinMap
            (addExtraCost)="selectionComponent.editExtraCost()"
            (addTailCharge)="selectionComponent.editTailCharge()"
            (pushpinCreated)="reloadPushpins()"
            (chooseInspection)="chooseInspection(customerArea)"
            [class.show]="view() === 'map'"
            [filterComponent]="filterComponent"
            [manualAreasComponent]="manualAreasComponent"
            [pushpinMoveComponent]="pushpinMoveComponent"
            [nearby]="nearby()" [selectionComponent]="selectionComponent" [view]="view()">
        </app-pushpin-map>


        <app-pushpin-list
            #pushpinList
            [class.show]="view() === 'list'"
            [selectionComponent]="selectionComponent"
            [filterComponent]="filterComponent" [nearby]="nearby()">
        </app-pushpin-list>

        <app-pushpin-filter #filter [class.listview]="view() === 'list'"></app-pushpin-filter>
        <app-manual-areas #manualAreas></app-manual-areas>
    </div>
</div>
<div [class.show]="view() === 'map-detail' || view() === 'list-detail'" class="detail">
    @if (view() === 'map-detail' || view() === 'list-detail') {
        <app-pushpin-detail
            #pushpinDetail
            (pushpinChanged)="reloadPushpins()"
            [customerArea]="customerArea"
            [inspection]="inspection"
            [nearby]="nearby()">
        </app-pushpin-detail>
    }
</div>
